import { useCallback, useContext, useState } from 'react'

import ErrorBoundary from '../../../containers/error_boundary'
import { ActionCableConsumerContext } from '../../../contexts/action_cable_consumer_context'
import { isLiveChatApp } from '../../../reduxes/slices/live_chat_app/selectors'
import { useSelectorDelegateStore } from '../../../reduxes/stores/root_store/hooks'

export const useCallsChannel = () => {
  const consumer = useContext(ActionCableConsumerContext)
  const [subscription, setSubscription] = useState()
  const liveChatApp = useSelectorDelegateStore(isLiveChatApp)

  const unsubscribe = useCallback(() => {
    if (subscription) {
      consumer.subscriptions.remove(subscription)
      setSubscription(undefined)
    }
  }, [consumer, subscription])

  const subscribe = useCallback(() => {
    if (subscription) {
      unsubscribe()
    }
    const params = {
      channel: 'CallsChannel',
    }
    if (liveChatApp) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      params['live_chat_jwt'] = localStorage.getItem(window.speakeasyData.jwtLsId)
    }
    const s = consumer.subscriptions.create(params, {
      rejected() {
        const error = new Error('Failed to subscribe to calls channel')
        ErrorBoundary.logErrorToMyService(error)
      },
    })
    setSubscription(s)
  }, [consumer, liveChatApp, subscription, unsubscribe])

  return {
    subscribe,
    unsubscribe,
  }
}
